<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="根号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" filterable @visible-change="getBreed">
                <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.original_length" multiple collapse-tags placeholder="长度" filterable @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.original_thickness" multiple collapse-tags placeholder="直径" filterable @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" filterable @visible-change="getSelectWarehouseList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.locker_id" multiple collapse-tags placeholder="锁定人" filterable @visible-change="getSelectWarehouseList('locker_id')">
                <el-option v-for="list in selectMapC.locker_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.batch_no" placeholder="批次号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.ship_no" placeholder="船名" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.heap_no" placeholder="堆号" size="mini"></el-input>
            <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库日期"></el-date-picker>
                </div>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <!-- <el-button  class="publicBtn" @click="filterDialogVisible=!filterDialogVisible">过滤</el-button> -->
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="stock.wood.spots" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber" v-if="totalObj.numbers||Number(totalObj.numbers)==0">总件数: {{totalObj.numbers}}</div>
            <div class="totalNumber" v-if="totalObj.cube_total||Number(totalObj.cube_total)==0">总方数: {{totalObj.cube_total}}</div>
            <div class="totalNumber" v-if="totalObj.lock_numbers||Number(totalObj.lock_numbers)==0">锁定件数: {{totalObj.lock_numbers}}</div>
            <div class="totalNumber" v-if="totalObj.lock_cube_total||Number(totalObj.lock_cube_total)==0">锁定方数: {{totalObj.lock_cube_total}}</div>
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="stock.wood.spots" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
    </div>
</template>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                dialogVisibleWidth:false,
                isShowMore:false,
                widthList:[],
                inbound_time:"",
                params:{
                    bale_no:"",
                    breed_id:"",
                    original_length:"",
                    original_thickness:"",
                    heap_no:"",
                    warehouse_id:"",
                    locker_id:"",
                    supplier_id:"",
                    contract_no:"",
                    bill_lading_no:"",
                    batch_no:"",
                    ship_no:"",
                    inbound_time:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                breedList:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    locker_id:[]
                },
                searchCityList:[],
                statusList:[],
                // dialog
                dialogVisible : false,
                tableCol:[	
                    {colName:"状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"根号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"直径",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"锁定人",colKey:"locker_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"到期日",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{
                    numbers:0,
                    cube_total:0,
                    lock_numbers:0,
                    lock_cube_total:0
                },
                fields:"",
                filterDialogVisible:false,
                filter:"",
                selectRow:[],
                selectCube:0.0000
            }
        },
        created(){
            this.postFunc("/erp/inventory.spots.status",{},res=>{
                this.statusList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getBreed()
        },
        methods:{
            getRow(row){
                this.selectRow = row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
            exportExcelBill(){
                this.$exportExecl("/erp/stock.wood.spots.export","原木现货库存",this.params)
            },
            getBreed(){
                this.postFunc("/erp/processing.wood.breed",{processing_id:this.processing_id},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,1).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.inbound_time = this.formatTimeZero(this.inbound_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/stock.wood.spots",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj=res.data.data.total;
                    this.totalObj.cube_total=this.keepLimit(this.totalObj.cube_total)
                    this.totalObj.lock_cube_total=this.keepLimit(this.totalObj.lock_cube_total)
                    this.list.forEach((item,ind)=>{
                        if(item.inbound_time&&item.inbound_time!=0){
                            this.list[ind].inbound_time = this.formatTimeSecond(item.inbound_time*1000) 
                        }else{
                            this.list[ind].inbound_time ='';
                        }
                        if(item.expiry_time){
                            this.list[ind].expiry_time = this.formatTime(this.list[ind].expiry_time+"000")
                        }else{
                            this.list[ind].expiry_time = "";
                        }
                        // this.list[ind].sales_width_total = parseInt(this.list[ind].sales_width_total);
                        item.baseColor = "";
                        if(item.status==1&&item.lock_status==0){
                            item.baseColor="#222";
                        }else if(item.status==2){
                            item.baseColor="#B400FF";
                        }else if(item.status==3){
                            item.baseColor="#155BD4";
                        }else if(item.status==4){
                            item.baseColor="#007B04";
                        }else if(item.status==1&&item.lock_status==1){
                            item.baseColor="#FF0000";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            reset(){
                this.inbound_time="";
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
